import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import ProductRow from '../components/ProductRow';
import CategoryFilter from '../components/CategoryFilter';
import ProductCard from '../components/ProductCard';
import Hero from '../components/Hero';
import { API_URL } from '../config';

const API = API_URL;

const Home = () => {
  const { t } = useLang();
  const [products, setProducts]           = useState([]);
  const [categories, setCategories]       = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');
  const [search, setSearch]               = useState('');
  const [loading, setLoading]             = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/products`)
      .then(r => setProducts(r.data.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    axios.get(`${API}/products/categories`)
      .then(r => setCategories(r.data.data.filter(c => c.id !== 'all')))
      .catch(() => setCategories([]));
  }, []);

  const byCategory = (cat) => products.filter(p => p.category === cat);

  const filtered = products.filter(p => {
    const matchCat    = activeCategory === 'all' || p.category === activeCategory;
    const matchSearch = !search || p.name.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  // Une rangée par catégorie qui a réellement des produits en base (triées par volume de stock côté API)
  const sections = categories.map(c => ({
    id: c.id,
    icon: c.icon,
    titleKey: `section_${c.id.replace(/-/g, '_')}`,
    fallbackLabel: c.label,
  }));

  return (
    <main>
      <Hero />
      <section className="filter-section-v2" id="products">
        <div className="filter-section-v2__inner">
          <div className="search-bar-v2">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder={t('nav_search_placeholder')}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button onClick={() => setSearch('')} className="search-clear-v2">✕</button>
            )}
          </div>
          <CategoryFilter
            active={activeCategory}
            onChange={cat => { setActiveCategory(cat); setSearch(''); }}
          />
        </div>
      </section>

      {(search || activeCategory !== 'all') && (
        <section className="search-results">
          <div className="search-results__header">
            <h2>{filtered.length} {t('results_found')}</h2>
            <button className="btn btn--ghost btn--sm" onClick={() => { setSearch(''); setActiveCategory('all'); }}>
              {t('clear_filters')}
            </button>
          </div>
          {loading ? (
            <div className="loader-grid">
              {[...Array(4)].map((_, i) => <div key={i} className="skeleton-card" />)}
            </div>
          ) : filtered.length === 0 ? (
            <div className="no-results">
              <span>😕</span>
              <p>{t('no_results')}</p>
            </div>
          ) : (
            <div className="product-grid">
              {filtered.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </section>
      )}

      {!search && activeCategory === 'all' && (
        <div className="category-rows">
          {loading ? (
            <div className="loader-grid">
              {[...Array(4)].map((_, i) => <div key={i} className="skeleton-card" />)}
            </div>
          ) : (
            sections
              .filter(sec => byCategory(sec.id).length > 0)
              .map(sec => (
                <ProductRow
                  key={sec.id}
                  id={sec.id}
                  title={t(sec.titleKey) !== sec.titleKey ? t(sec.titleKey) : sec.fallbackLabel}
                  icon={sec.icon}
                  products={byCategory(sec.id)}
                />
              ))
          )}
        </div>
      )}
    </main>
  );
};

export default Home;
